"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tensor = void 0;
const tensor_impl_js_1 = require("./tensor-impl.js");
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.Tensor = tensor_impl_js_1.Tensor;
//# sourceMappingURL=tensor.js.map